<script lang="ts">
	//UI
	import { DefaultButton } from "@hitit/new_ui";
	import TimeSelection from "../../v7/component/atu/TimeSelection.svelte";
	//Utils
	//Types
	//Props
	export let requesterImage: string;
	export let storename: string;
	export let time: string;
	export let posting = false;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="body">
	<img id="requester" src={requesterImage || ''} alt="Requester" />
	<div class="texts">
		<div class="main">
			<img src="/img/icons/AppLock.png" alt="lock" />
			<span class="title">잠금해제 요청</span>
		</div>
		<div class="description">
			{storename}관리자님,<br />
			잠금 해제 요청의 응답을 선택해 전송해주세요
		</div>
	</div>
	<div class="timeselection">
		<TimeSelection bind:value={time} />
	</div>
	<div class="button-box">
		<DefaultButton fitmode on:click disabled={time === ''} isLoading={posting}>
			<span class="button-text"> 전송 </span>
		</DefaultButton>
	</div>
</div>

<style lang="scss">
	.body {
		display: flex;
		flex-direction: column;
		gap: 30px;
		padding-top: 30px;
		align-items: center;
		img#requester {
			width: 231px;
			height: 231px;
			object-fit: cover;
			border-radius: 100%;
		}

		.texts {
			display: flex;
			flex-direction: column;
			gap: 20px;
			.main {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 10px;
				img {
					width: 20.8px;
					height: 30px;
					object-fit: contain;
				}
				.title {
					font-size: 1.25rem;
					font-weight: 500;
					color: #46474b;
				}
			}
			.description {
				line-height: 25px;
				color: #46474b;
				text-align: center;
			}
		}
		.timeselection {
			width: 100%;
			box-sizing: border-box;
			padding: 0px 40px;
		}
		.button-box {
			width: 100%;
			height: 32px;
			box-sizing: border-box;
			padding: 0px 20px;
			.button-text {
				display: inline-block;
				font-weight: 500;
				color: white;
				margin-bottom: 2px;
			}
		}
	}

</style>
